import timeline from './timeline';

//owlcarousel owl=slider
let params = {
    items:2,
    dots:true,
    autoplay:true,
    autoHeight: false,
    loop:true,
    autoplayHoverPause:true,
    stopOnHover : true,
    nav: true,
    mouseDrag: false,
    touchDrag: false,
    navText: ["",""],
    responsive:{
      0 : {
        items: 1
      },
      768: {
        items: 2,          
        margin: 20
      },
      992: {
        items: 2,          
        margin: 20
      },
      1200:{
        items: 2,
        margin: 50
      }
    }
}

$('#main-tabs .nav-item a').on('click',function(e){
    e.stopPropagation();
    //set breadcrumbs
    $('.breadcrumbs__wrapper ul li:last-child').remove();
    $('.breadcrumbs__wrapper ul').append('<li>'+$(this).text()+'</li>');
    //load content
    let idDiv = $(this).attr('id').split('-')[0];
    let target = $("#"+idDiv).attr('data-load'); 
    getContent(target, idDiv);

    $('.nav-tabs a[href="#'+idDiv+'"]').tab('show');     
    $('.owl-item .nav-link').removeClass('active');
    $(e.target).addClass('active');
});

let url = document.location.toString();
if (url.match('#')) {
    $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');

    let idDiv = url.split('#')[1];
    let target = $('#'+url.split('#')[1]).attr('data-load');
    //set breadcrumbs
    $('.breadcrumbs__wrapper ul').append('<li>'+$('#'+idDiv+'-tab').text()+'</li>');
    getContent(target, idDiv);

    setTimeout(function(){
      $('.owl-item .nav-link').removeClass('active');
      $('a[href="#' + url.split('#')[1] + '"]').addClass('active');      
    },500)
}else{
    //first load
    if($('#main-tabs').length > 0){
        let firstTab =  $('.nav-tabs a.active').attr('id').split('-')[0];
        let target = $("#"+firstTab).attr('data-load'); 
        //set breadcrumbs
        $('.breadcrumbs__wrapper ul').append('<li>'+$('.nav-tabs a.active').text()+'</li>');
        getContent(target, firstTab);
    }
} 



function getContent(id,target){
    let slug = id;
    let origin   = window.location.origin;

    if(!$('#'+target).attr('data-loaded')){        
        //set loader
        $('.loader').removeClass('loader--disabled');
        $.ajax({
            url: origin+slug,
            type: 'GET',
            success: function(res) {              
                $('#'+target).append(res);  
                //owlcarousel active
                $('.owl-slider-with-numbers').owlCarousel(params);
                // console.log(params.items);
                $('.slider-with-numbers .owl-dots').wrap('<div class="dots-wrapper"></div>');
                $('.dots-wrapper').append('<button class="stop"><svg id="Layer_1" class="stop__svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66"><g><path class="cls-1" d="M53.92,10.081a31,31,0,1,1-43.839,0A31,31,0,0,1,53.92,10.081Z" transform="translate(0.999 1)"/><line class="cls-1" x1="25.999" y1="24" x2="25.999" y2="42"/><line class="cls-1" x1="38.999" y1="24" x2="38.999" y2="42"/></g></svg>');
                $('.dots-wrapper').append('<button class="start"><svg id="Layer_1" class="start__svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66"><path class="cls-1" d="M53.92,10.081a31,31,0,1,1-43.839,0A31,31,0,0,1,53.92,10.081Z" transform="translate(1 1)"/><polygon class="cls-2" points="29.799 42 29.799 24 41.799 33 29.799 42"/></svg></button>');
                $('.stop').on('click',function(){
                    $('.owl-slider-with-numbers').owlCarousel(params).trigger('stop.owl.autoplay');
                    $('.stop').hide();
                    $('.start').show();
                })
                $('.start').on('click',function(){
                    $('.owl-slider-with-numbers').owlCarousel(params).trigger('play.owl.autoplay',[1000]);
                    $('.start').hide();
                    $('.stop').show();
                })

                timeline();
                //accordions active
                //add attr loaded
                $('#'+target).attr('data-loaded',true);            
                setTimeout(function(){          
                    //remove loader
                    $('.loader').addClass('loader--disabled');
                     $('html, body').animate({           
                         scrollTop: $('#'+target).offset().top-200
                     }, 200);
                },500);
            }
        });
    } else {
        $('html, body').animate({
            scrollTop: $('#top').offset().top + $('#top').height()
        }, 200);
//        console.log($('#' + target).offset().top, $('#' + target), '#' + target);
    }

}
